var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.buttonsWrapper},[_c('div',{class:_vm.secondary ? _vm.$style.secondaryButtons : _vm.$style.primaryButtons},[_vm._t("default",null,{"secondary":_vm.secondary})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }